// Common utility functions shared between store files
// This helps break circular dependencies between Zustand stores

/**
 * Utility to clear all data stores during logout or account switching
 * This is extracted to avoid circular dependencies between stores
 */
export const clearStoreData = (stores: Record<string, any>) => {
  try {
    // Call clearAccounts on accountsStore if available
    if (stores.accountsStore?.clearAccounts) {
      stores.accountsStore.clearAccounts();
    }
    
    // Call clearCategories on categoriesStore if available
    if (stores.categoriesStore?.clearCategories) {
      stores.categoriesStore.clearCategories();
    }
    
    // Call clearTransactions on transactionsStore if available
    if (stores.transactionStore?.clearTransactions) {
      stores.transactionStore.clearTransactions();
    }
    
    // Call resetSettings on profileStore if available
    if (stores.profileStore?.resetSettings) {
      stores.profileStore.resetSettings();
    }
    
    // Call clearRates on currencyStore if available
    if (stores.currencyStore?.clearRates) {
      stores.currencyStore.clearRates();
    }
    
    console.log('All data stores cleared successfully');
  } catch (error) {
    console.error('Error clearing data stores:', error);
    throw error;
  }
}; 